<template>
  <div>
    <custom-animation :data="animationData" class="tick" speed="0.5" custom="top: 35%; left: 48%;"></custom-animation>
  </div>
</template>

<script>
import CustomAnimation from '../CustomAnimationWithLottieWithModal';
import tick from './tick.json';

export default {
  components: {
    CustomAnimation
  },
  data() {
    return {
      animationData: tick
    }
  }
};
</script>

<style lang="scss" scoped>
.tick {
  transform: scale(1.5);
}
</style>
